<div class="auth-status-page">
  <div class="auth-status-brand" aria-label="Roots by EarthScout">
    <img src="assets/images/earthscoutIcon.PNG" alt="" width="40" height="40" />
    <span>ROOTS</span>
  </div>
  <section class="auth-status-card" role="status" aria-live="polite" aria-busy="true">
    <div class="auth-status-indicator" aria-hidden="true">
      <span class="auth-status-spinner"></span>
      <mat-icon>lock_outline</mat-icon>
    </div>
    <div class="auth-status-eyebrow">Welcome to Roots</div>
    <h1>Signing you in…</h1>
    <p>We’re getting your workspace ready.<br />You’ll be redirected automatically.</p>
    <div class="auth-status-progress" aria-hidden="true"><span></span></div>
  </section>
  <p class="auth-status-footer">An EarthScout Smart platform</p>
</div>
